import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateLeadValue as UpdateLeadValueMutation,
    UpdateLeadValueVariables,
    LeadValueUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_LEAD_VALUE from '../mutations/update-lead-value.graphql';

export const useUpdateLeadValue = (): {
    updateLeadValue: (arg1: LeadValueUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateLeadValue, {loading, error}] = useMutation<
        UpdateLeadValueMutation,
        UpdateLeadValueVariables
    >(UPDATE_LEAD_VALUE);

    return {
        updateLeadValue: (input: LeadValueUpdateInput) => updateLeadValue({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
